module.exports = __webpack_public_path__ + "static/media/Bath7.8f90b52c.jpg";